/**
 * 登录态分作用域存储：前台 / 管理端互不覆盖
 * 禁止 localStorage.clear()
 */

const FRONTEND_TOKEN = 'frontend_token';
const FRONTEND_USER = 'frontend_user';
const ADMIN_TOKEN = 'admin_token';
const ADMIN_USER = 'admin_user';
/** 兼容旧版单 key */
const LEGACY_TOKEN = 'auth-token';

export type AuthScope = 'frontend' | 'admin';

export function isAdminPath(pathname = window.location.pathname): boolean {
  return pathname === '/admin' || pathname.startsWith('/admin/');
}

export function getAuthScope(pathname = window.location.pathname): AuthScope {
  return isAdminPath(pathname) ? 'admin' : 'frontend';
}

export function getToken(scope?: AuthScope): string | null {
  const s = scope || getAuthScope();
  if (s === 'admin') {
    return localStorage.getItem(ADMIN_TOKEN) || localStorage.getItem(LEGACY_TOKEN);
  }
  return localStorage.getItem(FRONTEND_TOKEN) || localStorage.getItem(LEGACY_TOKEN);
}

export function setAuthSession(
  scope: AuthScope,
  token: string,
  user: unknown,
  extra?: { mustChangePassword?: boolean }
) {
  if (scope === 'admin') {
    localStorage.setItem(ADMIN_TOKEN, token);
    localStorage.setItem(ADMIN_USER, JSON.stringify({ ...(user as object), ...extra }));
  } else {
    localStorage.setItem(FRONTEND_TOKEN, token);
    localStorage.setItem(FRONTEND_USER, JSON.stringify({ ...(user as object), ...extra }));
  }
  // 切号覆盖：清理旧单 key，避免串用
  localStorage.removeItem(LEGACY_TOKEN);
}

export function clearAuthScope(scope?: AuthScope) {
  const s = scope || getAuthScope();
  if (s === 'admin') {
    localStorage.removeItem(ADMIN_TOKEN);
    localStorage.removeItem(ADMIN_USER);
  } else {
    localStorage.removeItem(FRONTEND_TOKEN);
    localStorage.removeItem(FRONTEND_USER);
  }
  localStorage.removeItem(LEGACY_TOKEN);
}

export function getStoredUser(scope?: AuthScope): any | null {
  const s = scope || getAuthScope();
  const raw = localStorage.getItem(s === 'admin' ? ADMIN_USER : FRONTEND_USER);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function replaceToken(token: string, scope?: AuthScope) {
  const s = scope || getAuthScope();
  if (s === 'admin') localStorage.setItem(ADMIN_TOKEN, token);
  else localStorage.setItem(FRONTEND_TOKEN, token);
  localStorage.removeItem(LEGACY_TOKEN);
}

/** 简单解析 JWT payload（不校验签名，仅读标记） */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function tokenRequiresPasswordChange(token: string | null): boolean {
  if (!token) return false;
  const payload = decodeJwtPayload(token);
  return !!payload?.mustChangePassword;
}
